export default __webpack_public_path__ + "static/SaintsandStars-ResetPassword-604ce1b01458921b5b18561b43b1a22a.jpg";